export enum LanguageCode {
    EnglishUs = 'en-us',
    SpanishSpain = 'es-es',
    FrenchFrance = 'fr-fr',
    // SpanishArgentina = 'es-ar',
}

export const LANGUAGE_CODES = Object.values(LanguageCode)
export const SUPPORTED_LANGUAGE_PAIRS = {
    [LanguageCode.EnglishUs]: [LanguageCode.SpanishSpain],
    [LanguageCode.SpanishSpain]: [LanguageCode.EnglishUs],
    [LanguageCode.FrenchFrance]: [LanguageCode.EnglishUs],
}